/* CARTRI - Personaliza tu pack. Suma lo elegido, calcula el ahorro
   frente al precio anterior, muestra la progress bar de desbloqueo del
   reloj Garett (a partir de un umbral) y añade el regalo automáticamente. */
(function () {
  'use strict';
  var CFG = window.LIQ || {};
  var UMBRAL = CFG.freeShippingThreshold || 0;

  /* Icono regalo (mismo trazado que snippets/liq-icon.liquid) para
     el HTML que se inyecta desde JS, donde no hay Liquid. */
  var GIFT_ICO = '<svg class="liq-ico" style="width:1.2rem;height:1.2rem;vertical-align:-0.15em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5" rx="1"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';

  function money(c) {
    try {
      return new Intl.NumberFormat(CFG.locale || 'es-ES', {
        style: 'currency', currency: CFG.currency || 'EUR'
      }).format(c / 100);
    } catch (e) { return (c / 100).toFixed(2) + ' EUR'; }
  }

  function init(root) {
    if (!root || root.hasAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');

    var UNLOCK = Number(root.getAttribute('data-unlock-threshold')) || 0;
    var UNLOCK_VARIANT = root.getAttribute('data-unlock-variant') || '';
    var UNLOCK_TITLE = root.getAttribute('data-unlock-title') || '';
    var UNLOCK_PRICE = Number(root.getAttribute('data-unlock-price')) || 0;

    /* Colores del regalo (negro/oro). Los publica el section en
       data-gifts; el BXGY de Shopify hace gratis el que se anada. */
    var GIFTS = [];
    try { GIFTS = JSON.parse(root.getAttribute('data-gifts') || '[]'); } catch (e) { GIFTS = []; }
    var giftIdx = 0;

    var opts = [].slice.call(root.querySelectorAll('[data-liq-opt]'));
    var listEl = root.querySelector('[data-sum-list]');
    var emptyEl = root.querySelector('[data-sum-empty]');
    var antesEl = root.querySelector('[data-sum-antes]');
    var totalEl = root.querySelector('[data-sum-total]');
    var saveEl = root.querySelector('[data-sum-save]');
    var shipEl = root.querySelector('[data-sum-ship]');
    var unlockEl = root.querySelector('[data-sum-unlock]');
    var unlockLabel = root.querySelector('[data-unlock-label]');
    var unlockFill = root.querySelector('[data-unlock-fill]');
    var giftChoiceEl = root.querySelector('[data-gift-choice]');
    var giftOptsEl = root.querySelector('[data-gift-opts]');
    var btn = root.querySelector('[data-sum-add]');
    if (!opts.length || !btn) return;

    /* Lote del reloj: en 0 no se promete ni se añade el regalo */
    var AGOTADO = Number(CFG.giftStock) === 0;

    /* Chips de color del regalo: se montan una sola vez */
    if (giftOptsEl && GIFTS.length && !giftOptsEl.childNodes.length) {
      GIFTS.forEach(function (g, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('data-gift-pick', i);
        b.className = i === 0 ? 'is-on' : '';
        b.textContent = colorCorto(g.t);
        b.addEventListener('click', function () {
          giftIdx = i;
          [].slice.call(giftOptsEl.children).forEach(function (c, ci) {
            c.className = ci === i ? 'is-on' : '';
          });
          pintar();
        });
        giftOptsEl.appendChild(b);
      });
    }

    function num(el, attr) { return Number(el.getAttribute(attr)) || 0; }

    function elegirRegalo(total) {
      if (AGOTADO) return null;
      var ganado = opts.some(function (o) {
        return num(o, 'data-n') > 0 && o.getAttribute('data-gift');
      }) || (UNLOCK && total >= UNLOCK && UNLOCK_VARIANT);
      if (ganado && GIFTS.length) {
        var g = GIFTS[Math.min(giftIdx, GIFTS.length - 1)];
        return { variant: g.v, title: g.t, price: Number(g.p) || 0 };
      }
      if (UNLOCK && total >= UNLOCK && UNLOCK_VARIANT) {
        return { variant: UNLOCK_VARIANT, title: UNLOCK_TITLE, price: UNLOCK_PRICE };
      }
      return null;
    }

    function colorCorto(t) {
      var w = (t || '').trim().split(/\s+/);
      return w.length >= 2 ? w.slice(-2).join(' ') : (t || 'Regalo');
    }

    /* Aplica un filtro de tipo a un paso (visible/hidden en cada opt) */
    function aplicarFiltro(paso, val) {
      [].slice.call(paso.querySelectorAll('[data-liq-opt]')).forEach(function (o) {
        var t = o.getAttribute('data-type') || '';
        if (val === '*' || t === val) {
          o.removeAttribute('hidden');
        } else {
          o.setAttribute('hidden', 'hidden');
        }
      });
    }

    /* Filtro inicial: cada barra aplica el chip que Liquid marca
       como activo (por defecto Padel), sin esperar a un clic */
    [].slice.call(root.querySelectorAll('[data-liq-filterbar]')).forEach(function (bar) {
      var activo = bar.querySelector('.is-on') || bar.querySelector('[data-liq-filter]');
      if (activo && bar.closest('.liq-step')) {
        aplicarFiltro(bar.closest('.liq-step'), activo.getAttribute('data-liq-filter'));
      }
    });

    function pintar() {
      var total = 0, antes = 0, filas = '', unidades = 0;

      opts.forEach(function (o) {
        var n = num(o, 'data-n');
        var max = num(o, 'data-max') || 99;
        o.classList.toggle('is-on', n > 0);
        var menos = o.querySelector('[data-menos]');
        var mas = o.querySelector('[data-mas]');
        var cifra = o.querySelector('[data-cifra]');
        if (cifra) cifra.textContent = n;
        if (menos) menos.disabled = n <= 0;
        if (mas) mas.disabled = n >= max;
        if (!n) return;
        unidades += n;
        var p = num(o, 'data-price');
        // Gate anti-fuga: solo cuenta un compare real (> price). Con la campaña
        // apagada el Liquid emite data-compare vacío o igual al precio (regla
        // «solo el Hot Seat lleva tachados»): sin esto pintaría ahorro 0 o un
        // tachado que no existe.
        var c = num(o, 'data-compare');
        if (!(c > p)) c = p;
        total += p * n;
        antes += c * n;
        filas += '<li><span>' + (n > 1 ? n + ' x ' : '') +
          (o.getAttribute('data-title') || '') + '</span><span>' + money(p * n) + '</span></li>';
      });

      var regalo = elegirRegalo(total);
      var desbloqueado = UNLOCK > 0 && total >= UNLOCK;
      if (regalo) {
        antes += regalo.price;
        filas += '<li class="is-gift"><span>' + GIFT_ICO + ' ' + regalo.title + ' (regalo)</span>' +
          '<span class="liq-garett__gift-total"><s>' + money(regalo.price) + '</s> GRATIS</span></li>';
      }

      if (listEl) listEl.innerHTML = filas;
      if (emptyEl) emptyEl.hidden = unidades > 0;
      if (antesEl) antesEl.innerHTML = antes > total ? '<s>' + money(antes) + '</s>' : '';
      if (totalEl) totalEl.textContent = money(total);

      /* Nota de lote al desbloquear: cifra real, sin dramatismo */
      var stockRestanteTxt = '';
      if (typeof CFG.giftStock === 'number' && CFG.giftStock > 0) {
        stockRestanteTxt = '&middot; quedan ' + CFG.giftStock;
      }

      if (unlockEl && UNLOCK > 0) {
        unlockEl.hidden = false;
        unlockEl.classList.toggle('is-out', AGOTADO);
        if (AGOTADO) {
          root.classList.remove('is-unlocked');
          unlockEl.classList.remove('is-done');
          if (unlockFill) unlockFill.style.width = '0%';
          if (unlockLabel) unlockLabel.textContent = 'Lote de Activity 2 agotado';
        } else {
          /* % exacto contra el umbral: 100 solo al llegar o pasarlo,
             floor evita mostrar barra llena con el pack incompleto */
          var pct = total >= UNLOCK ? 100 : Math.floor((total / UNLOCK) * 100);
          if (unlockFill) unlockFill.style.width = pct + '%';
          root.classList.toggle('is-unlocked', desbloqueado);
          unlockEl.classList.toggle('is-done', desbloqueado);
          if (unlockLabel) {
            unlockLabel.innerHTML = desbloqueado
              ? GIFT_ICO + ' Regalo desbloqueado: <b>' + UNLOCK_TITLE + '</b> GRATIS' +
                (stockRestanteTxt ? ' <span class="liq-sum__unlock-stock">' + stockRestanteTxt + '</span>' : '')
              : 'Te faltan <b>' + money(UNLOCK - total) + '</b> para tu reloj Garett de regalo';
          }
        }
      }

      if (giftChoiceEl) {
        giftChoiceEl.hidden = !(regalo && GIFTS.length);
      }

      if (saveEl) {
        var save = antes - total;
        if (save > 0) {
          saveEl.hidden = false;
          saveEl.textContent = 'Te ahorras ' + money(save) + ' con este pack';
        } else { saveEl.hidden = true; }
      }

      if (shipEl && UMBRAL) {
        if (!unidades) {
          shipEl.hidden = true;
        } else if (total >= UMBRAL) {
          shipEl.hidden = false;
          shipEl.className = 'liq-sum__ship is-done';
          shipEl.textContent = 'Envio gratis incluido';
        } else {
          shipEl.hidden = false;
          shipEl.className = 'liq-sum__ship';
          shipEl.textContent = 'Te faltan ' + money(UMBRAL - total) + ' para el envio gratis';
        }
      }

      btn.disabled = unidades === 0;
      btn.textContent = unidades === 0
        ? (btn.getAttribute('data-empty-label') || 'Elige tu equipo')
        : 'Anadir ' + unidades + (unidades === 1 ? ' articulo' : ' articulos') + ' al carrito';
    }

    root.addEventListener('click', function (e) {
      var chip = e.target.closest ? e.target.closest('[data-liq-filter]') : null;
      if (chip) {
        e.preventDefault();
        var bar = chip.closest('[data-liq-filterbar]');
        var paso = chip.closest('.liq-step');
        var val = chip.getAttribute('data-liq-filter');
        [].slice.call(bar.children).forEach(function (c) {
          c.className = c === chip ? 'is-on' : '';
        });
        aplicarFiltro(paso, val);
        return;
      }
      var b = e.target.closest ? e.target.closest('[data-mas],[data-menos]') : null;
      if (!b) return;
      e.preventDefault();
      var o = b.closest('[data-liq-opt]');
      if (!o) return;
      var n = num(o, 'data-n');
      var max = num(o, 'data-max') || 99;
      n = b.hasAttribute('data-mas') ? Math.min(max, n + 1) : Math.max(0, n - 1);
      o.setAttribute('data-n', n);
      pintar();
    });

    btn.addEventListener('click', function () {
      var items = [];
      var total = 0;
      opts.forEach(function (o) {
        var n = num(o, 'data-n');
        if (n > 0) {
          items.push({ id: Number(o.getAttribute('data-variant')), quantity: n });
          total += num(o, 'data-price') * n;
        }
      });
      if (!items.length) return;

      var regalo = elegirRegalo(total);
      if (regalo && !items.some(function (i) { return i.id === Number(regalo.variant); })) {
        items.push({ id: Number(regalo.variant), quantity: 1 });
      }

      var txt = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Anadiendo...';
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          items: items,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var d = document.querySelector('cart-drawer');
          if (d && typeof d.renderContents === 'function') {
            d.renderContents(data);
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } else { window.location.href = '/cart'; }
        })
        .catch(function () { window.location.href = '/cart'; })
        .then(function () { btn.disabled = false; btn.textContent = txt; });
    });

    pintar();
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-liq-pack]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
